// stitches.config.ts
import { createStitches } from "@stitches/react";
import type { CSS } from "@stitches/react";

const stitches = createStitches({
  theme: {
    colors: {
      primary: "#166534",
      lighterGreen: "#388E3C",
    },
    fonts: {
      sans: "Inter, sans-serif",
    },
  },
  media: {
    xs: "(min-width: 400px)",
    sm: "(min-width: 640px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)",
    xl: "(min-width: 1280px)",
    xsRev: "(max-width: 399.98px)",
    smRev: "(max-width: 639.98px)",
    mdRev: "(max-width: 767.98px)",
    lgRev: "(max-width: 1023.98px)",
    xlRev: "(max-width: 1279.98px)",
    heightSmallMdToXl:
      "(min-width: 768px) and (max-height: 800px) and (max-width: 1279px )",
  },
});

export const injectGlobalStyles = stitches.globalCss({
  ":root": {
    "--black": "#000",
  },
  "*": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  "html, body": {
    fontFamily: '"Open Sans", sans-serif',
    "@smRev": { overflowX: "hidden" },
    "&::-webkit-scrollbar": { width: "10px", height: "10px" },
    "&::-webkit-scrollbar-thumb": { background: "#a76700" },
    "&::-webkit-scrollbar-track": { background: "#533300" },
    backgroundColor: "#000",
    fontSize: 12,
    "@lg": {
      // prevent weird scroll bounce on mac browsers (was causing some fixed items to bounce up above the nav bar)
      overscrollBehavior: "none",
    },
  },
});

injectGlobalStyles();

const { config } = stitches;

export const { styled, css, keyframes } = stitches;
export type StitchesProp = CSS<typeof config>;

export default stitches;
